import React from 'react';

import { Controller } from 'react-hook-form';

import { AutoCompleteCN } from './autoCompleteCN';

type ControlledProps = {
  multiple?: boolean;
  onSelectCallback?(args: any): void;
  /** Quando informado, o valor gravado no form será getValueFromOption(option) em vez do option inteiro (ex.: option.value para enums) */
  getValueFromOption?(option: any): any;
} & Omit<React.ComponentProps<typeof AutoCompleteCN>, 'onChange' | 'onFocus' | 'onBlur'> &
  Omit<React.ComponentProps<typeof Controller>, 'as'>;

export function AutoCompleteCTL({ control, name, onSelectCallback, getValueFromOption, ...rest }: ControlledProps) {
  const handleOnChange = (args: any[]) => {
    const option = args[1];
    if (onSelectCallback) {
      onSelectCallback(option);
    }
    const valueToSet = getValueFromOption ? getValueFromOption(option) ?? option : option;
    return valueToSet;
  };

  return <Controller as={AutoCompleteCN} name={name ?? ''} control={control} onChange={handleOnChange} {...rest} />;
}
